import LinearRates from "./LinearRates";

export default LinearRates;
